/**
 * Name pools for generating synthetic people in test and dev-only tooling.
 *
 * Deliberately varied in origin: test data that is uniformly Anglo-Saxon hides
 * defects in name handling (diacritics, apostrophes, ordering) that real
 * caseloads surface immediately.
 *
 * Non-empty tuple types so `pickRandom` can guarantee a result.
 */
export const SAMPLE_FORENAMES = [
    "Amara",
    "Benjamin",
    "Chloe",
    "Damien",
    "Esme",
    "Farhan",
    "Grace",
    "Hassan",
    "Isla",
    "Javed",
    "Kezia",
    "Liam",
    "Maya",
    "Niamh",
    "Oliver",
];
export const SAMPLE_SURNAMES = [
    "Adeyemi",
    "Bennett",
    "Chakraborty",
    "Davies",
    "Evans",
    "Fletcher",
    "Griffiths",
    "Hassan",
    "Ibrahim",
    "Jenkins",
    "Khan",
    "Lawson",
    "Mackenzie",
    "Nwachukwu",
    "O'Brien",
];
//# sourceMappingURL=names.js.map